import { Search } from 'lucide-react';
import {
   ADD_OUT_ADJUSTMENT,
   ADD_VOUCHER,
   ADJUSTMENT_VOUCHER_BALANCE,
   ADJUSTMENT_VOUCHER_DETAILS,
   DELETE_VOUCHER,
   GET_ADJUSTED_VOUCHER,
   GET_BANK_VOUCHER,
   GET_LAST_VOUCHER_DAYBOOK,
   GET_ONE_VOUCHER,
   GET_VOUCHER,
   LAST_VOUCHER_DETAILS,
   PENDING_VOUCHER_DETAILS,
   SET_PENDING_VOUCHER,
   UPDATE_VOUCHER,
   UPDATE_VOUCHER_CLEARING_DATE,
   VOUCHER_PREV_NEXT,
   GET_GLOBAL_SEARCH,
} from '../types';

const initialState = {
   // list: [],
   // otAdj: [],
   // adjustedVoucher: [],
   // single: null,
   // lastVoucher: null,
   // lastVoucherDaybook: null,
   // totalCount: 0,
   // pendingVoucher: null,
   // adjustmentVoucher: null,
   // voucher_prev_next: null,
   // adj_voucher_balance: 0,
   // bankList: [],
   Search: [],
   // pagination: {
   //    limit: 10,
   //    nextPage: null,
   //    totalPages: 1,
   //    currentPage: 1,
   //    hasNextPage: false,
   //    previousPage: null,
   //    totalProducts: 0,
   //    hasPreviousPage: false,
   // },
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_GLOBAL_SEARCH:
         return { ...state, Search: payload.data};

      // case GET_BANK_VOUCHER:
      //    return { ...state, bankList: payload.data, totalCount: totalCount, pagination: payload.pagination };

      // case UPDATE_VOUCHER:
      //    return {
      //       ...state,
      //       list: state.list.map((item) => (item.id === payload.id ? payload : item)),
      //    };

      // case UPDATE_VOUCHER_CLEARING_DATE:
      //    return {
      //       ...state,
      //       list: state.list.map((item) => (item.id === payload.id ? payload : item)),
      //    };

      // case ADD_VOUCHER:
      //    return {
      //       ...state,
      //       list: [payload, ...state.list],
      //       totalCount: state.totalCount + 1,
      //    };

      // case ADD_OUT_ADJUSTMENT:
      //    return {
      //       ...state,
      //       otAdj: [payload, ...state.otAdj],
      //       totalCount: state.totalCount + 1,
      //    };

      // case LAST_VOUCHER_DETAILS:
      //    return {
      //       ...state,
      //       lastVoucher: payload,
      //    };

      // case GET_ADJUSTED_VOUCHER:
      //    return {
      //       ...state,
      //       adjustedVoucher: payload,
      //    };

      // case PENDING_VOUCHER_DETAILS:
      //    return {
      //       ...state,
      //       pendingVoucher: payload,
      //    };

      // case ADJUSTMENT_VOUCHER_DETAILS:
      //    return {
      //       ...state,
      //       adjustmentVoucher: payload,
      //    };

      // case ADJUSTMENT_VOUCHER_BALANCE:
      //    return {
      //       ...state,
      //       adj_voucher_balance: payload,
      //    };

      // case VOUCHER_PREV_NEXT:
      //    return {
      //       ...state,
      //       voucher_prev_next: payload,
      //    };

      // case DELETE_VOUCHER:
      //    return {
      //       ...state,
      //       list: state.list.filter((item) => item.id !== payload.id),
      //       totalCount: state.totalCount - 1,
      //    };

      // case GET_LAST_VOUCHER_DAYBOOK:
      //    return {
      //       ...state,
      //       lastVoucherDaybook: payload,
      //    };

      // case GET_ONE_VOUCHER:
      //    return { ...state, single: payload || initialState.single };

      // case SET_PENDING_VOUCHER:
      //    return {
      //       ...state,
      //       pendingVoucher: payload,
      //       lastVoucher: null,
      //    };

      // case 'CLEAR_SINGLE_VOUCHER':
      //    return {
      //       ...state,
      //       single: null,
      //    };

      default:
         return state;
   }
};

export default reducer;
